import { useEffect, useState } from 'react'
import { useI18n } from '../lib/i18n'

export function UpdatePrompt(){
  const {t}=useI18n()
  const [worker,setWorker]=useState<ServiceWorker|null>(null)
  useEffect(()=>{const listener=(event:Event)=>setWorker((event as CustomEvent<ServiceWorker>).detail);window.addEventListener('clashcards:update-ready',listener);return()=>window.removeEventListener('clashcards:update-ready',listener)},[])
  if(!worker)return null
  return <div className="update-prompt" role="status"><span>{t('updateReady')}</span><button onClick={()=>worker.postMessage({type:'SKIP_WAITING'})}>{t('updateNow')}</button></div>
}
